module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "mb-1": ""
      }
    }, [_c('v-card', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.click(item)
        }
      }
    }, [_c('v-card-text', [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-chips-field', {
      attrs: {
        "emptyChip": "Паспортные данные",
        "solo": "",
        "flat": "",
        "items": item.passportId ? [{
          value: item.passportId + '',
          text: item.text,
          hint: item.text,
          error: null
        }] : [],
        "chipSize": _vm.getIsMobile ? 25 : 25
      },
      on: {
        "remove": function($event) {
          return _vm.removePassport(item)
        },
        "click": function($event) {
          return _vm.clickPassport(item)
        }
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-chips-field', {
      attrs: {
        "emptyChip": "Контактная информация",
        "solo": "",
        "flat": "",
        "items": item.contactId ? [{
          value: item.contactId + '',
          text: _vm.getContact(item),
          hint: _vm.getContactHint(item),
          error: null
        }] : [],
        "chipSize": _vm.getIsMobile ? 25 : 25
      },
      on: {
        "remove": function($event) {
          return _vm.removeContact(item)
        },
        "click": function($event) {
          return _vm.clickContact(item)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c32bf77c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/HolderList.vue
// module id = 911
// module chunks = 1